import { WorkspaceLifecycle } from 'app/app.types';
import { environment } from 'environments/environment';

export function resolveWorkspaceLifecycle(
    selectedOrganization: any | null,
    selectedBranch: any | null
): WorkspaceLifecycle | null {
    const branchLifecycle = selectedBranch?.lifecycle;
    if (branchLifecycle) {
        return branchLifecycle;
    }

    const organizationLifecycle = selectedOrganization?.lifecycle;
    if (organizationLifecycle) {
        return organizationLifecycle;
    }

    const fromEnv = environment.user?.app_lifecycle || null;
    if (fromEnv) {
        return fromEnv;
    }

    const fromApp = environment.app_lifecycle || null;
    if (fromApp) {
        return fromApp;
    }

    return null;
}
